import { motion } from "framer-motion";
import { Award, MapPin, ShieldCheck } from "lucide-react";

const POINTS = [
  {
    icon: Award,
    title: "25+ jaar ervaring",
    desc: "Een kwart eeuw vakmanschap in platte daken, isolatie en grootschalige renovaties.",
  },
  {
    icon: MapPin,
    title: "Actief in heel Vlaanderen & Brussel",
    desc: "Van kleine renovaties tot grote projecten — wij komen ter plaatse in gans de regio.",
  },
  {
    icon: ShieldCheck,
    title: "Uitsluitend hoogwaardige materialen",
    desc: "Wij werken enkel met bewezen, duurzame materialen voor een resultaat dat blijft.",
  },
];

const IMG = "https://static.prod-images.emergentagent.com/jobs/ec229dca-3286-4c3f-80bd-c5baa5296531/images/0c9799dbc25c5971009b4841e62b14fb2d361b713563c4fffdf26ab9c01cbd23.png";

export const WhyUs = () => {
  return (
    <section id="waarom" data-testid="why-section" className="py-24 md:py-32 bg-sefco-surface">
      <div className="mx-auto max-w-7xl px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative"
        >
          <img src={IMG} alt="Sefco dakdekkers aan het werk" className="w-full h-[380px] lg:h-[520px] object-cover grayscale-[15%]" />
          <div className="absolute -bottom-6 -right-6 hidden sm:block bg-sefco-blue text-white p-6 md:p-8 max-w-[220px]">
            <div className="font-heading font-black text-4xl">25+</div>
            <div className="text-sm uppercase tracking-wider mt-1">Jaar op de daken van Vlaanderen</div>
          </div>
          <div className="absolute inset-0 border border-white/10 pointer-events-none" />
        </motion.div>

        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-sefco-blue" />
            <span className="text-sm uppercase tracking-[0.2em] text-zinc-400 font-medium">Onze belofte</span>
          </div>
          <h2 className="font-heading font-bold text-white text-3xl sm:text-5xl tracking-tight mb-10">Waarom Sefco?</h2>

          <div className="space-y-6">
            {POINTS.map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={p.title}
                  data-testid={`why-point-${i}`}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="group flex gap-5 items-start border-b border-neutral-800 pb-6"
                >
                  <div className="shrink-0 border border-neutral-700 group-hover:border-sefco-blue group-hover:bg-sefco-blue p-3 transition-colors">
                    <Icon size={24} strokeWidth={1.5} className="text-sefco-blue group-hover:text-white transition-colors" />
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-lg sm:text-xl text-white">{p.title}</h3>
                    <p className="text-zinc-400 mt-1 leading-relaxed">{p.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
